import React from 'react'
import { Box, Typography } from '@mui/material'
import styles from './AppDownloadSection.module.scss'
import shouldShowPlayStore from '../../utils/shouldShowPlayStore'

const AppDownloadSection = ({ type = 0 }) => {
  const email = 'investor@royalsmartlimousine.com'
  const phone = '+971 4 397 7746'
  return (
    <Box sx={{ padding: type === 1 ? '6rem 0rem' : '12rem 0rem', color: 'white' }}>
      <section className={styles.downloadSection}>
        <div className={styles.container}>
          <div className={styles.imageBlock}>
            <img
              src={`${process.env.IMAGE_BASE_URL}/images/userwebsite/app/device.png`}
              alt='RSL App Mockup'
              className={styles.mockupImage}
            />
          </div>
          <div className={styles.textBlock}>
            <h2 className={styles.title}>
              Book a<span className={styles.primary}> Chauffeur</span>
              <br />
              Now!
            </h2>
            <p className={styles.description}>
              Download the RSL Mobile App and experience luxury at your
              fingertips. Whether it&rsquo;s for business or leisure, schedule your
              ride in seconds and travel in style, anytime, anywhere.
            </p>
            <div className={styles.storeButtons}>
              {
                shouldShowPlayStore() &&
                <a
                  href='https://play.google.com/store/apps/details?id=com.rsl.luxurycab.passenger'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <img src={`${process.env.IMAGE_BASE_URL}/images/userwebsite/app/googleplay.png`} alt='Google Play' />
                </a>
              }
              <a
                href='https://apps.apple.com/in/app/rsl-car-booking-service/id1351219496'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img src={`${process.env.IMAGE_BASE_URL}/images/userwebsite/app/appstore.png`} alt='App Store' />
              </a>
            </div>

          </div>
        </div>
      </section>
      {type === 1 && (
        <div
          className={`footer-content mt-40 text-center d-flex flex-column align-items-center`}
          style={{
            color: '#ffffff',
          }}
        >
          <h5
            className='text-20 fw-500 mb-30'
            style={{
              color: '#ffffff',
            }}
          >
            Investment
          </h5>

          <div className='d-flex y-gap-10 mb-10 text-16 flex-column footer-content_menus text-center'>
            {email}
          </div>

          <div
            className='d-flex y-gap-10 flex-column footer-content_menus text-center'
            style={{ color: '#ffffff', fontWeight: 'bold' }}
          >
            {phone}
          </div>
        </div>
      )}


    </Box>
  )
}

export default AppDownloadSection
